var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAir = function SvgAir(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb09388d-6e13-4164-8dc4-ea80a9190fa4",
    "data-name": "Layer 6",
    viewBox: "0 0 137.96 110.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M104.84,33.49H48.15a2.36,2.36,0,1,1,0-4.71h56.69c5.9,0,10.69-5.21,10.69-11.62S110.74,5.53,104.84,5.53a2.36,2.36,0,0,1,0-4.71c8.49,0,15.39,7.33,15.39,16.34S113.33,33.49,104.84,33.49Z",
    transform: "translate(-18 -0.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M36.79,33.1H30.12a2.36,2.36,0,0,1,0-4.71h6.67a2.36,2.36,0,0,1,0,4.71Z",
    transform: "translate(-18 -0.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M148.14,84.17a19.31,19.31,0,0,1-17.6,2.89h0c-12.15-3.91-16.09-14.74-14.6-23.15.08-.45.17-.89.29-1.32a2.35,2.35,0,0,1,2.27-1.78,2.79,2.79,0,0,1,.58.07,2.35,2.35,0,0,1,1.7,2.87,10,10,0,0,0-.2,1c-.89,5,.52,14.33,11.37,17.84a14.47,14.47,0,0,0,13.36-2.12c4-3.1,6.18-8.31,6-14.38,0-9.35-8.6-16.39-20-16.39H62.36a2.36,2.36,0,1,1,0-4.71h68.86c14.09,0,24.72,9.07,24.72,21C156.21,73.5,153.38,80.13,148.14,84.17Z",
    transform: "translate(-18 -0.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M35.94,63.21H53.22a2.36,2.36,0,0,1,0,4.71H35.94a2.36,2.36,0,0,1,0-4.71Z",
    transform: "translate(-18 -0.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M20.36,63.21h5.49a2.36,2.36,0,0,1,0,4.71H20.36a2.36,2.36,0,1,1,0-4.71Z",
    transform: "translate(-18 -0.82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M33,49.66A2.35,2.35,0,0,1,33,45H51.79a2.35,2.35,0,1,1,0,4.7Z",
    transform: "translate(-18 -0.82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M62.38,96.74a2.36,2.36,0,0,1,3.24.76,19.4,19.4,0,1,0,17-29.6l-.09,0H65.37a2.36,2.36,0,0,1,0-4.71H81.06c.35,0,.7,0,1,0A24.11,24.11,0,1,1,61.63,100,2.34,2.34,0,0,1,62.38,96.74Z",
    transform: "translate(-18 -0.82)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a2725852-9682-4633-b5d0-b60ffad743b7",
    d: "M24,45h.44a2.36,2.36,0,0,1,0,4.72H24A2.36,2.36,0,1,1,24,45Z",
    transform: "translate(-18 -0.82)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAir, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/air.027f6aa9.svg";
export { ForwardRef as ReactComponent };